export default __webpack_public_path__ + "static/media/drdong-lg-2x.34aec1cb.jpg";